import { useParams } from "react-router-dom";
import FacultyTemplate from "./FacultyTemplate";
import { facultiesdata } from "../../data/facultiesdata";

const FacultyPage = () => {
  const { facultyName } = useParams();

  const faculty = facultiesdata[facultyName];

  return <FacultyTemplate faculty={faculty} />;
};

export default FacultyPage;
